import { addStyles } from 'ethcss'
import { colors, grid, IStyles } from 'theme'
import { mediaCSS, textSizes } from 'theme/media'
import { defaultThemeStyles as defaultThemeAppStyles } from 'blocks.app/app/app.theme.jcss'
const mediaWidth600pxQuery = '@media (max-width: 600px)'

const styles: IStyles = {
    scrollRoot: {
        width: '100%',
        height: '100%',
        minHeight: 0,
        flex: 1,
    },
    wrapper: {
        ...grid.col,
        ...grid.justify,
        ...grid.fullWidth,
        minHeight: '100%',
        maxHeight: '100%',
        boxSizing: 'border-box',
        ...grid.p_md,
        paddingBottom: 0,
        overflow: 'hidden',
    },
    errorInputText: {
        color: 'red',
        fontSize: '12px',
    },
    deviceParametersWrapper: {
        ...grid.col,
        ...grid.justify,
        ...grid.fullWidth,
        minHeight: '100%',
        maxHeight: '100%',
        boxSizing: 'border-box',
        padding: '32px 24px 24px',
        [mediaCSS.tabMini]: {
            height: 'auto',
            maxHeight: 'none',
        },
        backgroundColor: `var(--var-module-app-component-app-style-panel, ${defaultThemeAppStyles.panel})`,
    },
    noBoxShadow: {
        boxShadow: 'none !important',
    },
    w100: {
        width: 'auto !important',
    },
    formWrapper: {
        width: '54%',
        ...grid.row,
        [mediaWidth600pxQuery]: {
            height: '100%',
        },
        [mediaCSS.desktopXL]: {
            width: '65%',

            [mediaCSS.desktopML]: {
                width: '80%',

                [mediaCSS.desktopML]: {
                    ...grid.w100,
                },
            },
        },
    },
    form: {
        ...grid.row,
        ...grid.w100,
    },
    title: {
        fontWeight: 'bold',
        display: 'block',
        width: '100%',
        textAlign: 'center',
        fontSize: textSizes.mdPlus,
        flexShrink: 0,
        ...grid.mb_md,
        [mediaCSS.tabMini]: {
            ...grid.mb_md,
        },
    },
    inputLabel: {
        ...grid.mb_micro,
        textTransform: 'uppercase',
        display: 'block',
        width: '100%',
        textAlign: 'center',
        fontSize: textSizes.normalPlus,
    },
    content: {
        ...grid.col,
        ...grid.fullWidth,
        ...grid.space,
        alignItems: 'center',
        justifyContent: 'flex-start',
        minHeight: 0,
        overflowY: 'auto',
        [mediaCSS.tabMini]: {
            ...grid.mb_md,
        },
    },
    descriptionWrapper: {
        ...grid.w50,
        [mediaCSS.tabMini]: {
            ...grid.w100,
        },
    },
    leftColumnContent: {
        ...grid.col,
        ...grid.w45,
        ...grid.mr_md,
        [mediaCSS.tabMini]: {
            ...grid.w100,
            ...grid.mr_none,
        },
    },
    rightColumnContent: {
        ...grid.w50,
        [mediaCSS.tabMini]: {
            ...grid.w100,
            ...grid.row,
        },
    },
    footer: {
        ...grid.row,
        ...grid.center,
        flexShrink: 0,
        paddingTop: 16,
        paddingBottom: 8,
        [mediaCSS.tabMini]: {
            ...grid.mb_md,
        },
    },
    displaysAddVirtualDevice__inputWrapper_type_tags: {
        ...grid.mb_micro,
        [mediaCSS.tabMini]: {
            ...grid.w100,
        },
    },
    disabled: {
        opacity: 0.5,
    },
    noLicensesLeft: {
        display: 'flex',
        marginTop: 14,
        color: colors.notificationRed,

        span: {
            marginLeft: 10,
            fontSize: 11,
        },
    },
    licenseOption: {
        padding: 6,
        borderRadius: 5,
        backgroundColor: 'transparent',
        width: '100%',
        transition: 'background-color 0.3s',

        '&:hover': {
            backgroundColor: '#E9ECF1',
        },
    },
    licenseOptionRow: {
        display: 'flex',
        justifyContent: 'space-between',
    },
    licenseOptionName: {
        fontWeight: 'bold',
    },
    licenseOptionDesc: {
        borderRadius: 5,
        backgroundColor: '#F2F4F7',
        fontWeight: 'normal',

        span: {
            color: colors.blueAccent,

            span: {
                color: 'rgba(37, 130, 224, 0.50)',
            },
        },
    },
    lic: {
        [mediaCSS.tabMini]: {
            width: '100%',
        },
    },
}

addStyles(styles)
export default styles
